import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import Footer from "@/components/Footer";
import { LOGO_URL } from "@/lib/siteData";

export const LEGAL_UPDATED = "Version 1.2 — mise à jour le 22 octobre 2026";

export default function LegalLayout({ eyebrow, title, updated = LEGAL_UPDATED, testId, children }) {
  useEffect(() => {
    document.title = `${title} — MD Courtage`;
    window.scrollTo(0, 0);
  }, [title]);

  return (
    <div className="bg-md-bg min-h-screen text-md-text" data-testid={testId}>
      <header className="bg-white/90 backdrop-blur-md border-b border-md-border sticky top-0 z-20">
        <div className="max-w-4xl mx-auto px-6 py-4 flex items-center justify-between">
          <Link to="/" data-testid="legal-logo-link"><img src={LOGO_URL} alt="MD Courtage" className="h-14 object-contain" /></Link>
          <Link to="/" data-testid="legal-back-home" className="inline-flex items-center gap-1.5 text-sm text-md-muted hover:text-md-primary transition-colors">
            <ArrowLeft className="w-4 h-4" /> Retour au site
          </Link>
        </div>
      </header>
      <main className="max-w-4xl mx-auto px-6 py-16 md:py-24 animate-fade-up">
        <div className="text-xs uppercase tracking-[0.25em] text-md-accent font-bold mb-4">{eyebrow}</div>
        <h1 className="font-serif text-4xl sm:text-5xl text-md-primary font-medium leading-tight mb-4">{title}</h1>
        {updated && <p className="text-sm text-md-muted mb-14">{updated}</p>}
        <div className="space-y-12">{children}</div>
      </main>
      <Footer />
    </div>
  );
}

export const Section = ({ n, title, children }) => (
  <section className="border-t border-md-border pt-8">
    <h2 className="font-serif text-xl md:text-2xl text-md-primary font-medium mb-4">
      {n && <span className="text-md-secondary mr-2">{n}.</span>}{title}
    </h2>
    <div className="space-y-3 text-[15px] leading-relaxed text-md-text/90">{children}</div>
  </section>
);

export const List = ({ items }) => (
  <ul className="list-disc pl-5 space-y-1.5 marker:text-md-secondary">
    {items.map((i, k) => <li key={k}>{i}</li>)}
  </ul>
);

export const ToFill = ({ children }) => (
  <span className="bg-amber-100 text-amber-900 px-1.5 py-0.5 rounded text-[13px]">[{children}]</span>
);
